import { CalendarClock } from "lucide-react"
import { useLocation } from "wouter"
import { formatDateTime } from "@/lib/dates"

interface ScheduledPlanLinkProps {
  /** Generated-post id the Posting-Plan should focus (`?post=`). */
  postId: string
  scheduledFor: string | Date | null | undefined
  /** Prefix before the date. Default "Geplant für"; pass "Veröffentlicht am" for already-posted items. */
  label?: string
  /** e.g. close the surrounding modal before the route change. */
  onBeforeNavigate?: () => void
  testId?: string
}

// The "Geplant für <Datum>" pill that deep-links into the Posting-Plan — used on list
// cards and inside the posts modal so the two stay visually and behaviorally identical.
// For already-published items pass label="Veröffentlicht am" (posts stay in the plan by date).
export function ScheduledPlanLink({ postId, scheduledFor, label = "Geplant für", onBeforeNavigate, testId }: ScheduledPlanLinkProps) {
  const [, setLocation] = useLocation()
  return (
    <button
      type="button"
      onClick={() => {
        onBeforeNavigate?.()
        setLocation(`/veroeffentlichungsplan?post=${postId}`)
      }}
      title="Im Veröffentlichungsplan öffnen"
      className="inline-flex items-center gap-1 rounded-full border border-blue-300 px-2.5 py-0.5 text-xs font-semibold text-blue-600 hover:bg-blue-50 dark:text-blue-400 dark:border-blue-700 dark:hover:bg-blue-950/40 transition-colors"
      data-testid={testId}
    >
      <CalendarClock className="h-3 w-3" />
      {label} {scheduledFor ? formatDateTime(scheduledFor) : "…"}
    </button>
  )
}
